export default __webpack_public_path__ + "static/media/6 - Выставки творчества.0a8294c4.jpg";